<template>
	<div
		class="cco-catalogSorting"
		:class="{ 'cco-catalogSorting--active': isOpen }"
		v-click-away="close"
	>
		<div class="button" @click="isOpen = !isOpen">
			<span v-if="selectedOption">{{
				translations[selectedOption.title]
			}}</span>
			<span v-else>{{ translations["Sort by"] }}</span>
			<ArrowIcon></ArrowIcon>
		</div>

		<Transition name="fade">
			<div class="menu" v-if="isOpen">
				<div
					class="menu__item"
					v-for="option in options"
					:key="option.value"
					@click="changeSort(option)"
				>
					{{ translations[option.title] }}
				</div>
			</div>
		</Transition>
	</div>
</template>

<script>
import { mixin as VueClickAway } from "vue3-click-away";
import ArrowIcon from "@web/assets/icon/arrow-full.svg";

export default {
	name: "CatalogSorting",
	mixins: [VueClickAway],
	components: {
		ArrowIcon,
	},
	data: () => {
		return {
			isOpen: false,
			selectedOption: null,
			options: [
				{ title: "Sort", value: "title" },
				{ title: "Popularity", value: "popularity" },
				{ title: "Rating", value: "rating" },
				{ title: "Newest", value: "newest" },
				{ title: "Price: Low to high", value: "price" },
				{ title: "Price: High to low", value: "price-desc" },
			],
		};
	},
	methods: {
		changeSort(option) {
			if (!option.value) {
				this.selectedOption = null;
			} else {
				this.selectedOption = option;
			}
			this.$emit("changed", option.value);
			this.close();
		},
		close() {
			this.isOpen = false;
		},
	},
};
</script>

<style lang="scss">
@import "@backend/scss/abstracts/variables.scss";
@import "@backend/scss/abstracts/mixins.scss";

.cco-catalogSorting {
	position: relative;
	.button {
		width: fit-content;
		cursor: pointer;

		display: flex;
		justify-content: center;
		align-items: center;

		min-height: 47px;
		height: 47px;

		padding-inline: 16px;

		border-radius: 2px;
		border: $e-border-blue;
		transition: $t-hover all;
		span {
			// @include text-overflow(1);
			transition: $t-hover all;
			white-space: nowrap;
			font-size: $font-small-size;
			font-weight: $f-medium;

			text-transform: uppercase;
			color: $c-blue;
		}

		svg {
			width: 13px;
			margin-left: 9px;

			path {
				transition: $t-hover all;
			}
		}

		&:hover {
			transition: $t-hover all;
			background-color: $c-blue;
			span {
				transition: $t-hover all;
				color: $c-white;
			}
			svg {
				path {
					transition: $t-hover all;
					fill: $c-white;
				}
			}
		}
	}
	.menu {
		position: absolute;
		top: 0;
		background-color: $c-white;
		width: fit-content;
		min-width: 192px;

		z-index: 2;
		right: 0;
		box-shadow: $e-shadow;
		border-radius: 2px;

		&__item {
			cursor: pointer;
			padding-inline: 16px;
			padding-top: 15px;
			padding-bottom: 15px;
			line-height: 18px;
			text-align: center;
			border-top: $e-border;
			white-space: nowrap;

			&:first-of-type {
				border-top: none;
			}
			transition: $t-hover all;
			&:hover {
				transition: $t-hover all;
				background-color: $c-greylight;
			}
		}
	}

	&--active {
		.button {
			border: 1px solid transparent;

			svg {
				transform: rotate(180deg);
			}
		}
	}
}

@media all and (max-width: 650px) {
	.cco-catalogSorting {
		// width: fit-content;
		width: 100%;

		.button {
			width: 100%;
		}
		.menu {
			left: 0;
			right: unset;
			width: 100%;
		}
	}
}
</style>
